// extracted by mini-css-extract-plugin
module.exports = {"container":"privacyCard_container__3-2kY","text":"privacyCard_text__2Bky9","learnButton":"privacyCard_learnButton__1i4Yb","icon":"privacyCard_icon__2kl8O"};